import PhoneInputComponent from 'react-phone-number-input';
import withFormLayout from '../HOC/withFormLayout';

const PhoneInput = ({
  //mandatory
  value,
  onChange,
  //optional
  isoptional,
  rightAddon,
  //comes from HOC
  namespace,
  styles,
}) => {
  return (
    <div style={{ containerType: rightAddon ? 'inline-size' : undefined }} className={rightAddon ? 'driver-mobile-wrapper' : undefined}>
      <PhoneInputComponent
        className={`form-control ${styles}`}
        defaultCountry={'PT'}
        international={false}
        options={['PT']}
        name={namespace}
        placeholder="000 000 000"
        value={value}
        onChange={onChange}
        isoptional={isoptional}
      />
      {rightAddon}
    </div>
  );
};

export default withFormLayout(PhoneInput);
